var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.$t("pages.locker.get_aform.upcoming_live_events.title"),
          "use-title-as-document-title": false
        }
      }),
      _vm._v(" "),
      _vm.liveStreamAnnouncements.length
        ? _c(
            "div",
            { staticClass: "row mb-3" },
            _vm._l(_vm.liveStreamAnnouncements, function(announcement) {
              return _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "card rounded shadow-sm" }, [
                  _c("div", { staticClass: "card-body bg-light" }, [
                    _c("h5", [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(announcement.title[_vm.$i18n.locale]) +
                            "\n                            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "mdi mdi-calendar" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-weight-lighter" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm
                              .$date(announcement.starts_at)
                              .format("DD.MM.YYYY HH:mm")
                          ) +
                          "\n                        "
                      )
                    ])
                  ])
                ])
              ])
            }),
            0
          )
        : _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                { staticClass: "alert alert-secondary border-dark shadow-sm" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "pages.locker.get_aform.upcoming_live_events.none"
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
      _vm._v(" "),
      _c("page-header", {
        attrs: {
          title: _vm.$t("pages.locker.get_aform.newest_trainings.title"),
          "use-title-as-document-title": false
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.latest_videos, function(video) {
          return _c(
            "div",
            { key: video.id, staticClass: "col-md-4  grid-margin" },
            [
              _c("gym-video-card-new", {
                attrs: { video: video, "page-link-enabled": true }
              })
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }